<template>
  <el-dialog
    title="Help"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    class="help-dialog"
  >
    <div class="help-section">
      <h4>Platform Overview</h4>
      <p>
        HybridORS Admin manages athlete profiles, DMWC morning check-ins, PBSQ question content and records,
        alert handling, and system users, roles, and menu permissions.
      </p>
    </div>
    <div class="help-section">
      <h4>Common Tasks</h4>
      <ul>
        <li><strong>Dashboard</strong>: View system metrics and quick entry points.</li>
        <li><strong>Sports Health</strong>: Maintain athlete profiles, morning check-ins, and alerts.</li>
        <li><strong>PBSQ</strong>: Maintain the full PBSQ question bank and review PBSQ records.</li>
        <li><strong>Members</strong>: View app users, linked coaches, and coach athlete lists.</li>
        <li><strong>System Management</strong>: Configure admins, roles, menus, and permissions.</li>
        <li><strong>Notifications</strong>: Use the bell icon to review pending active alerts.</li>
        <li><strong>Theme Colors</strong>: Use the brush icon to switch between theme palettes.</li>
      </ul>
    </div>
    <div class="help-section">
      <h4>Quick Links</h4>
      <div class="help-links">
        <el-button
          v-for="link in quickLinks"
          :key="link.path"
          size="small"
          @click="go(link.path)"
        >
          {{ link.label }}
        </el-button>
      </div>
    </div>
    <div class="help-section help-contact">
      <h4>Support</h4>
      <p>HybridORS Sports Health Platform</p>
      <p class="muted">For sign-in failures, abnormal data, or permission issues, contact the system administrator and include the operation time and page path.</p>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="dialogVisible = false">Got it</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'HeaderHelpDialog',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      quickLinks: [
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Athlete Profiles', path: '/health/athlete' },
        { label: 'PBSQ Question Bank', path: '/pbsq/question' },
        { label: 'Alert Management', path: '/health/alert' },
        { label: 'Admin List', path: '/system/admin' },
        { label: 'User List', path: '/member/app-user' },
        { label: 'Coach List', path: '/member/coach' }
      ]
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(v) { this.$emit('update:visible', v) }
    }
  },
  methods: {
    go(path) {
      this.dialogVisible = false
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>
.help-section {
  margin-bottom: 16px;
}
.help-section h4 {
  margin: 0 0 8px;
  color: #1d2129;
}
.help-section p,
.help-section li {
  margin: 0 0 6px;
  color: #4e5969;
  line-height: 1.6;
  font-size: 13px;
}
.help-section ul {
  margin: 0;
  padding-left: 18px;
}
.help-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.help-contact .muted {
  color: #86909c;
  font-size: 12px;
}
</style>
